export default {
  methods: {
    getScoreClass(score) {
      if (score < 0.5) {
        return 'poor';
      }
      if (score <= 0.75) {
        return 'moderate';
      } else {
        return 'strong';
      }
    },
  },
};
